import React, { useState, useEffect } from 'react';
import { useInView } from '../hooks/useInView';
import { C } from '../constants';
import { motion } from 'framer-motion';

export const AnimNum = ({ target, prefix = '', suffix = '' }) => {
  const { ref, v } = useInView();
  const [num, setNum] = useState(0);

  useEffect(() => {
    if (!v) return;
    let start = 0;
    const duration = 2000;
    const increment = target / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        setNum(target);
        clearInterval(timer);
      } else {
        setNum(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [v, target]);

  return (
    <span ref={ref}>
      {prefix}
      {num.toLocaleString()}
      {suffix}
    </span>
  );
};

export const BulletList = ({ items, small }) => {
  const { ref, v } = useInView();

  return (
    <div ref={ref} style={{ display: 'flex', flexDirection: 'column', gap: small ? '10px' : '16px' }}>
      {items.map((item, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, x: -20 }}
          animate={v ? { opacity: 1, x: 0 } : {}}
          transition={{ delay: i * 0.1, duration: 0.5 }}
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '12px',
            fontSize: small ? '14px' : '16px',
            lineHeight: 1.6
          }}
          className="font-[Manrope]"
        >
          <div
            style={{
              minWidth: small ? '6px' : '8px',
              width: small ? '6px' : '8px',
              height: small ? '6px' : '8px',
              borderRadius: '50%',
              background: C.secondary,
              marginTop: small ? '7px' : '8px'
            }}
          />
          <span style={{ opacity: 0.85 }}>{item}</span>
        </motion.div>
      ))}
    </div>
  );
};